// eslint-disable-next-line @typescript-eslint/no-floating-promises -- predates rule
import('./bootstrap');
